/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from 'ng2-translate/src/translate.pipe';
import * as import2 from 'ng2-translate/src/translate.service';
import * as import3 from '../../ui-elements/qr-code/qr-code-panel/qr-code-panel.component.ngfactory';
import * as import4 from '../../ui-elements/qr-code/qr-code-panel/qr-code-panel.component';
import * as import5 from '../../orchestration/navigation.service';
import * as import6 from '@angular/common';
import * as import7 from '../../store/store-details-panel/store-details-panel.component.ngfactory';
import * as import8 from '../../store/store-details-panel/store-details-panel.component';
import * as import9 from '../../orchestration/session.model';
import * as import10 from '../../orchestration/responsive.service';
import * as import11 from '../../ordering-context/ordering-context.model';
import * as import12 from '../../inputs/form/field-group/field-group.component.ngfactory';
import * as import13 from '../../inputs/form/field-group/field-group.component';
import * as import14 from '@angular/forms';
import * as import15 from '../../ui-elements/icon/icon.component.ngfactory';
import * as import16 from '../../ui-elements/icon/icon.component';
import * as import17 from '../order-extras-panel/order-extras-panel.component.ngfactory';
import * as import18 from '../order-extras-panel/order-extras-panel.component';
import * as import19 from '../../ui-elements/card-brand/card-brand.component.ngfactory';
import * as import20 from '../../ui-elements/card-brand/card-brand.component';
import * as import21 from '../../buttons/button/button.component.ngfactory';
import * as import22 from '../../buttons/button/button.component';
import * as import23 from '../order-totals-panel/order-totals-panel.component.ngfactory';
import * as import24 from '../order-totals-panel/order-totals-panel.component';
import * as import25 from '../order.model';
import * as import26 from '../../html-utils/html.pipe';
import * as import27 from '@angular/platform-browser';
import * as import28 from '../../string-utils/possessive.pipe';
import * as import29 from '../../string-utils/currency.pipe';
import * as import30 from './order-details-panel.component';
const styles_OrderDetailsPanelComponent:any[] = ([] as any[]);
export const RenderType_OrderDetailsPanelComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_OrderDetailsPanelComponent,
  data: {}
}
);
function View_OrderDetailsPanelComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),5,'div',[[
        'class',
        'order-transfer'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵppd(1),
    import0.ɵpod([
      'store',
      'groupOrderName'
    ]
    ),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    import0.ɵppd(1),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,0,0,ck(v,4,0,import0.ɵnov((<any>(<any>v.parent).parent),0),import0.ɵunv(v,0,0,import0.ɵnov(v,3).transform('woa.message.order.summary.transferredToGroupOrder',ck(v,2,0,co.recentOrder.initiatedOrder.store.name,import0.ɵunv(v,0,0,ck(v,1,0,import0.ɵnov((<any>(<any>v.parent).parent),1),co.recentOrder.orderInitiation.transferTargetName)))))));
    ck(v,0,0,currVal_0);
  });
}
function View_OrderDetailsPanelComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),9,'div',[[
        'class',
        'order-qr'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'order-qr-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-qr-code-panel',([] as any[]),(null as any),(null as any),(null as any),import3.View_QrCodePanelComponent_0,import3.RenderType_QrCodePanelComponent)),
    import0.ɵdid(49152,(null as any),0,import4.QrCodePanelComponent,[import5.NavigationService],{
      value: [
        0,
        'value'
      ]
      ,
      displayValue: [
        1,
        'displayValue'
      ]
      ,
      message: [
        2,
        'message'
      ]

    }
    ,(null as any)),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = co.recentOrder.placedOrder.lookupCode;
    const currVal_2:any = co.recentOrder.placedOrder.receiptId;
    const currVal_3:any = import0.ɵinlineInterpolate(1,'',import0.ɵunv(v,7,2,import0.ɵnov(v,8).transform('woa.label.order.details.qrCode')),'');
    ck(v,7,0,currVal_1,currVal_2,currVal_3);
  },(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,3,0,import0.ɵnov(v,4).transform('woa.label.order.details.qrCode'));
    ck(v,3,0,currVal_0);
  });
}
function View_OrderDetailsPanelComponent_6(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),5,'div',[[
        'class',
        'order-receiptId'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import6.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['with-time']),
    import0.ɵpod(['receiptId']),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    import0.ɵppd(1)
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = 'order-receiptId';
    const currVal_2:any = ck(v,2,0,co.orderTimeLabel);
    ck(v,1,0,currVal_1,currVal_2);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,0,0,ck(v,5,0,import0.ɵnov((<any>(<any>(<any>(<any>v.parent).parent).parent).parent),0),import0.ɵunv(v,0,0,import0.ɵnov(v,4).transform('woa.label.order.details.receiptId',ck(v,3,0,co.recentOrder.placedOrder.receiptId)))));
    ck(v,0,0,currVal_0);
  });
}
function View_OrderDetailsPanelComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),7,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderDetailsPanelComponent_5)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderDetailsPanelComponent_6)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.showQrCode;
    ck(v,3,0,currVal_0);
    const currVal_1:boolean = !co.showQrCode;
    ck(v,6,0,currVal_1);
  },(null as any));
}
function View_OrderDetailsPanelComponent_7(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'order-time'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵpod(['time']),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    import0.ɵppd(1)
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,0,0,ck(v,3,0,import0.ɵnov((<any>(<any>(<any>v.parent).parent).parent),0),import0.ɵunv(v,0,0,import0.ɵnov(v,2).transform(co.orderTimeLabel,ck(v,1,0,co.orderTime)))));
    ck(v,0,0,currVal_0);
  });
}
function View_OrderDetailsPanelComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),7,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderDetailsPanelComponent_4)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderDetailsPanelComponent_7)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.recentOrder.placedOrder.requestId;
    ck(v,3,0,currVal_0);
    const currVal_1:any = co.orderTimeLabel;
    ck(v,6,0,currVal_1);
  },(null as any));
}
function View_OrderDetailsPanelComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),7,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderDetailsPanelComponent_2)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderDetailsPanelComponent_3)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.recentOrder.orderInitiation.transferTargetId;
    ck(v,3,0,currVal_0);
    const currVal_1:boolean = !co.recentOrder.orderInitiation.transferTargetId;
    ck(v,6,0,currVal_1);
  },(null as any));
}
function View_OrderDetailsPanelComponent_8(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-store-details-panel',[[
        'class',
        'order-store'
      ]
    ],(null as any),(null as any),(null as any),import7.View_StoreDetailsPanelComponent_0,import7.RenderType_StoreDetailsPanelComponent)),
    import0.ɵdid(245760,(null as any),0,import8.StoreDetailsPanelComponent,[
      import9.SessionModel,
      import10.ResponsiveService,
      import11.OrderingContextModel,
      import0.ChangeDetectorRef
    ]
    ,{
      store: [
        0,
        'store'
      ]
      ,
      intention: [
        1,
        'intention'
      ]
      ,
      summary: [
        2,
        'summary'
      ]
      ,
      showStoreImage: [
        3,
        'showStoreImage'
      ]
      ,
      showTelephone: [
        4,
        'showTelephone'
      ]
      ,
      showMoreDetails: [
        5,
        'showMoreDetails'
      ]
      ,
      showStatus: [
        6,
        'showStatus'
      ]
      ,
      showActions: [
        7,
        'showActions'
      ]
      ,
      showMap: [
        8,
        'showMap'
      ]

    }
    ,(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.recentOrder.initiatedOrder.store;
    const currVal_1:any = co.OrderingContextIntention.NONE;
    const currVal_2:any = true;
    const currVal_3:any = false;
    const currVal_4:any = true;
    const currVal_5:any = false;
    const currVal_6:any = false;
    const currVal_7:any = false;
    const currVal_8:any = true;
    ck(v,1,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8);
  },(null as any));
}
function View_OrderDetailsPanelComponent_10(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'delivery-address-instructions'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.recentOrder.orderPlacement.deliveryInstructions;
    ck(v,1,0,currVal_0);
  });
}
function View_OrderDetailsPanelComponent_9(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),14,'woa-field-group',[[
        'class',
        'delivery-address'
      ]
    ],(null as any),(null as any),(null as any),import12.View_FieldGroupComponent_0,import12.RenderType_FieldGroupComponent)),
      import0.ɵdid(49152,(null as any),0,import13.FieldGroupComponent,([] as any[]),{title: [
        0,
        'title'
      ]
    },(null as any)),
    import0.ɵprd(5120,(null as any),import14.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import13.FieldGroupComponent]),
    (l()(),import0.ɵted(0,['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),0,1,'div',[[
        'class',
        'delivery-address-details'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted(0,['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),0,3,'div',[[
        'class',
        'delivery-address-mobile'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpod(['phoneNumber']),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted(0,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_OrderDetailsPanelComponent_10)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'woa.label.order.details.deliveringTo';
    ck(v,1,0,currVal_0);
    const currVal_3:any = co.recentOrder.orderPlacement.deliveryInstructions;
    ck(v,13,0,currVal_3);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = co.recentOrder.orderPlacement.address.formattedAddress;
    ck(v,5,0,currVal_1);
    const currVal_2:any = import0.ɵunv(v,8,0,import0.ɵnov(v,10).transform('woa.label.order.details.phoneNumber',ck(v,9,0,co.recentOrder.orderPlacement.mobilePhone)));
    ck(v,8,0,currVal_2);
  });
}
function View_OrderDetailsPanelComponent_15(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon',[[
        'class',
        'order-request-item-details-header-icon'
      ]
    ],(null as any),(null as any),(null as any),import15.View_IconComponent_0,import15.RenderType_IconComponent)),
      import0.ɵdid(573440,(null as any),0,import16.IconComponent,[import0.ChangeDetectorRef],{name: [
        0,
        'name'
      ]
    },(null as any))
  ]
  ,(ck,v) => {
    const currVal_0:any = 'tags';
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_OrderDetailsPanelComponent_17(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-order-extras-panel',[[
        'class',
        'order-request-item-details-component-extras'
      ]
    ],(null as any),(null as any),(null as any),import17.View_OrderExtrasPanelComponent_0,import17.RenderType_OrderExtrasPanelComponent)),
    import0.ɵdid(49152,(null as any),0,import18.OrderExtrasPanelComponent,([] as any[]),{
      item: [
        0,
        'item'
      ]
      ,
      showTotal: [
        1,
        'showTotal'
      ]

    }
    ,(null as any))
  ]
  ,(ck,v) => {
    const currVal_0:any = (<any>v.parent).context.$implicit;
    const currVal_1:any = true;
    ck(v,1,0,currVal_0,currVal_1);
  },(null as any));
}
function View_OrderDetailsPanelComponent_16(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'order-request-item-details-component'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'order-request-item-details-component-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                            ',
      '\n                        '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderDetailsPanelComponent_17)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    ']))
  ]
  ,(ck,v) => {
    const currVal_1:any = ((v.context.$implicit.orderedExtras == null)? (null as any): v.context.$implicit.orderedExtras.length);
    ck(v,6,0,currVal_1);
  },(ck,v) => {
    const currVal_0:any = v.context.$implicit.name;
    ck(v,3,0,currVal_0);
  });
}
function View_OrderDetailsPanelComponent_18(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-order-extras-panel',[[
        'class',
        'order-request-item-details-extras'
      ]
    ],(null as any),(null as any),(null as any),import17.View_OrderExtrasPanelComponent_0,import17.RenderType_OrderExtrasPanelComponent)),
    import0.ɵdid(49152,(null as any),0,import18.OrderExtrasPanelComponent,([] as any[]),{
      item: [
        0,
        'item'
      ]
      ,
      showTotal: [
        1,
        'showTotal'
      ]

    }
    ,(null as any))
  ]
  ,(ck,v) => {
    const currVal_0:any = (<any>v.parent).context.$implicit;
    const currVal_1:any = true;
    ck(v,1,0,currVal_0,currVal_1);
  },(null as any));
}
function View_OrderDetailsPanelComponent_14(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),26,'div',[[
        'class',
        'order-request-item'
      ]
      ],[[
        8,
        'id',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'order-request-item-qty'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                    ',
      '\n                '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),16,'div',[[
        'class',
        'order-request-item-details'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'order-request-item-details-header'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderDetailsPanelComponent_15)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'order-request-item-details-header-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                            ',
      '\n                        '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderDetailsPanelComponent_16)),
    import0.ɵdid(802816,(null as any),0,import6.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderDetailsPanelComponent_18)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'order-request-item-total'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                    ',
      '\n                '
    ]
    )),
    import0.ɵppd(1),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    const currVal_2:any = v.context.$implicit.deal;
    ck(v,10,0,currVal_2);
    const currVal_4:any = v.context.$implicit.compositeOrderItems;
    ck(v,17,0,currVal_4);
    const currVal_5:boolean = (!((v.context.$implicit.compositeOrderItems == null)? (null as any): v.context.$implicit.compositeOrderItems.length) && ((v.context.$implicit.orderedExtras == null)? (null as any): v.context.$implicit.orderedExtras.length));
    ck(v,20,0,currVal_5);
  },(ck,v) => {
    const currVal_0:any = import0.ɵinlineInterpolate(2,'order-request-item-',(<any>(<any>v.parent).parent).context.index,'.',v.context.index,'');
    ck(v,0,0,currVal_0);
    const currVal_1:any = v.context.$implicit.quantity;
    ck(v,3,0,currVal_1);
    const currVal_3:any = v.context.$implicit.name;
    ck(v,13,0,currVal_3);
    const currVal_6:any = import0.ɵunv(v,24,0,ck(v,25,0,import0.ɵnov((<any>(<any>(<any>(<any>v.parent).parent).parent).parent),2),((v.context.$implicit.initiatedTotal == (undefined as any))? v.context.$implicit.localTotal: v.context.$implicit.initiatedTotal)));
    ck(v,24,0,currVal_6);
  });
}
function View_OrderDetailsPanelComponent_19(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'order-request-subtotal'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'order-request-subtotal-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                    ',
      '\n                '
    ]
    )),
    import0.ɵpod(['name']),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'order-request-subtotal-price'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                    ',
      '\n                '
    ]
    )),
    import0.ɵppd(1),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,3,0,import0.ɵnov(v,5).transform((<any>(<any>v.parent).parent).context.$implicit.subtotalLabel,ck(v,4,0,(<any>(<any>v.parent).parent).context.$implicit.name)));
    ck(v,3,0,currVal_0);
    const currVal_1:any = import0.ɵunv(v,8,0,ck(v,9,0,import0.ɵnov((<any>(<any>(<any>(<any>v.parent).parent).parent).parent),2),(<any>(<any>v.parent).parent).context.$implicit.subTotal));
    ck(v,8,0,currVal_1);
  });
}
function View_OrderDetailsPanelComponent_13(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'woa-field-group',[[
        'class',
        'order-request'
      ]
    ],(null as any),(null as any),(null as any),import12.View_FieldGroupComponent_0,import12.RenderType_FieldGroupComponent)),
    import0.ɵdid(49152,(null as any),0,import13.FieldGroupComponent,([] as any[]),{
      title: [
        0,
        'title'
      ]
      ,
      translationParams: [
        1,
        'translationParams'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['name']),
    import0.ɵprd(5120,(null as any),import14.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import13.FieldGroupComponent]),
    (l()(),import0.ɵted(0,['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_OrderDetailsPanelComponent_14)),
    import0.ɵdid(802816,(null as any),0,import6.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_OrderDetailsPanelComponent_19)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.getRequestHeading((<any>v.parent).context.$implicit);
    const currVal_1:any = ck(v,2,0,(<any>v.parent).context.$implicit.name);
    ck(v,1,0,currVal_0,currVal_1);
    const currVal_2:any = (<any>v.parent).context.$implicit.items;
    ck(v,6,0,currVal_2);
    const currVal_3:any = co.totalTransfers;
    ck(v,9,0,currVal_3);
  },(null as any));
}
function View_OrderDetailsPanelComponent_12(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderDetailsPanelComponent_13)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    const currVal_0:any = v.context.$implicit.items.length;
    ck(v,3,0,currVal_0);
  },(null as any));
}
function View_OrderDetailsPanelComponent_20(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'woa-field-group',[[
        'class',
        'order-notes'
      ]
    ],(null as any),(null as any),(null as any),import12.View_FieldGroupComponent_0,import12.RenderType_FieldGroupComponent)),
      import0.ɵdid(49152,(null as any),0,import13.FieldGroupComponent,([] as any[]),{title: [
        0,
        'title'
      ]
    },(null as any)),
    import0.ɵprd(5120,(null as any),import14.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import13.FieldGroupComponent]),
    (l()(),import0.ɵted(0,['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),0,1,'div',[[
        'class',
        'order-notes-text'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted(0,['\n    ']))
  ]
  ,(ck,v) => {
    const currVal_0:any = 'woa.heading.order.notes';
    ck(v,1,0,currVal_0);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = (co.recentOrder.orderPlacement.requestId? co.recentOrder.orderPlacement.customerNotes: co.orderingContextModel.customerNotes);
    ck(v,5,0,currVal_1);
  });
}
function View_OrderDetailsPanelComponent_23(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-card-brand',[[
        'class',
        'order-payment-method-brand card-brand'
      ]
    ],(null as any),(null as any),(null as any),import19.View_CardBrandComponent_0,import19.RenderType_CardBrandComponent)),
      import0.ɵdid(573440,(null as any),0,import20.CardBrandComponent,([] as any[]),{brand: [
        0,
        'brand'
      ]
    },(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.recentOrder.orderPlacement.paymentAuthorisation.paymentCardBrand;
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_OrderDetailsPanelComponent_22(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),9,'div',[[
        'class',
        'order-payment-method'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderDetailsPanelComponent_23)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'order-payment-method-details'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpod([
      'points',
      'card'
    ]
    ),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (((co.recentOrder.orderPlacement.paymentAuthorisation.paymentType === 1) || (co.recentOrder.orderPlacement.paymentAuthorisation.paymentType === co.PaymentType.SAVED_CREDIT_CARD)) || (co.recentOrder.orderPlacement.paymentAuthorisation.paymentType === co.PaymentType.NEW_CREDIT_CARD));
    ck(v,3,0,currVal_0);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = import0.ɵunv(v,6,0,import0.ɵnov(v,8).transform(co.paymentMethod,ck(v,7,0,co.memberAvailableRedemptionPoints,co.recentOrder.orderPlacement.paymentAuthorisation.paymentCardLast4)));
    ck(v,6,0,currVal_1);
  });
}
function View_OrderDetailsPanelComponent_24(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-button',[[
        'class',
        'order-payment-action'
      ]
    ],[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.requestInvoice()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import21.View_ButtonComponent_0,import21.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import22.ButtonComponent,[
      import0.ElementRef,
      import9.SessionModel,
      import0.ChangeDetectorRef,
      import10.ResponsiveService
    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      prominence: [
        1,
        'prominence'
      ]

    }
    ,(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_27:any = 'woa.button.order.sendInvoice';
    const currVal_28:any = co.ButtonProminence.LOW;
    ck(v,1,0,currVal_27,currVal_28);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).overrideFlatBackgroundColor;
    const currVal_1:any = import0.ɵnov(v,1).overrideFlatForegroundColor;
    const currVal_2:any = import0.ɵnov(v,1).overrideOutlineBackgroundColor;
    const currVal_3:any = import0.ɵnov(v,1).overrideOutlineForegroundColor;
    const currVal_4:any = import0.ɵnov(v,1).overrideOutlineBorderColor;
    const currVal_5:any = import0.ɵnov(v,1).overrideRaisedBackgroundColor;
    const currVal_6:any = import0.ɵnov(v,1).overrideRaisedForegroundColor;
    const currVal_7:any = import0.ɵnov(v,1).disabled;
    const currVal_8:any = import0.ɵnov(v,1).invisible;
    const currVal_9:any = import0.ɵnov(v,1).hovered;
    const currVal_10:any = import0.ɵnov(v,1).native;
    const currVal_11:any = import0.ɵnov(v,1).button;
    const currVal_12:any = import0.ɵnov(v,1).firstTier;
    const currVal_13:any = import0.ɵnov(v,1).secondTier;
    const currVal_14:any = import0.ɵnov(v,1).highProminence;
    const currVal_15:any = import0.ɵnov(v,1).lowProminence;
    const currVal_16:any = import0.ɵnov(v,1).affirmativeConnotation;
    const currVal_17:any = import0.ɵnov(v,1).dissuasiveConnotation;
    const currVal_18:any = import0.ɵnov(v,1).negativeConnotation;
    const currVal_19:any = import0.ɵnov(v,1).squareShape;
    const currVal_20:any = import0.ɵnov(v,1).roundedShape;
    const currVal_21:any = import0.ɵnov(v,1).ovalShape;
    const currVal_22:any = import0.ɵnov(v,1).flatStyle;
    const currVal_23:any = import0.ɵnov(v,1).outlineStyle;
    const currVal_24:any = import0.ɵnov(v,1).raisedStyle;
    const currVal_25:any = import0.ɵnov(v,1).verticalLayout;
    const currVal_26:any = import0.ɵnov(v,1).horizontalLayout;
    ck(v,0,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26
    ]
    );
  });
}
function View_OrderDetailsPanelComponent_21(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),12,'woa-field-group',[[
        'class',
        'order-payment'
      ]
    ],(null as any),(null as any),(null as any),import12.View_FieldGroupComponent_0,import12.RenderType_FieldGroupComponent)),
      import0.ɵdid(49152,(null as any),0,import13.FieldGroupComponent,([] as any[]),{title: [
        0,
        'title'
      ]
    },(null as any)),
    import0.ɵprd(5120,(null as any),import14.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import13.FieldGroupComponent]),
    (l()(),import0.ɵted(0,['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),0,1,'woa-order-totals-panel',[[
        'class',
        'order-payment-totals'
      ]
    ],(null as any),(null as any),(null as any),import23.View_OrderTotalsPanelComponent_0,import23.RenderType_OrderTotalsPanelComponent)),
    import0.ɵdid(180224,(null as any),0,import24.OrderTotalsPanelComponent,[
      import11.OrderingContextModel,
      import25.OrderModel,
      import5.NavigationService,
      import0.ChangeDetectorRef
    ]
    ,{
      recentOrder: [
        0,
        'recentOrder'
      ]
      ,
      showZeroTip: [
        1,
        'showZeroTip'
      ]
      ,
      showSavings: [
        2,
        'showSavings'
      ]
      ,
      canEditTip: [
        3,
        'canEditTip'
      ]

    }
    ,(null as any)),
    (l()(),import0.ɵted(0,['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_OrderDetailsPanelComponent_22)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_OrderDetailsPanelComponent_24)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'woa.heading.order.paymentDetails';
    ck(v,1,0,currVal_0);
    const currVal_1:any = co.recentOrder;
    const currVal_2:any = false;
    const currVal_3:any = false;
    const currVal_4:any = false;
    ck(v,5,0,currVal_1,currVal_2,currVal_3,currVal_4);
    const currVal_5:any = (co.recentOrder.orderPlacement.requestId && (co.totalPayment > 0));
    ck(v,8,0,currVal_5);
    const currVal_6:boolean = (((!co.recentOrder.pending && co.recentOrder.orderPlacement.requestId) && (co.totalPayment > 0)) && ((co.sessionModel.currentApp == null)? (null as any): co.sessionModel.currentApp.orderReceivedEmail.id));
    ck(v,11,0,currVal_6);
  },(null as any));
}
function View_OrderDetailsPanelComponent_11(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),10,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderDetailsPanelComponent_12)),
    import0.ɵdid(802816,(null as any),0,import6.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderDetailsPanelComponent_20)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderDetailsPanelComponent_21)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.transferRequestDetails;
    ck(v,3,0,currVal_0);
    const currVal_1:boolean = (!co.recentOrder.orderInitiation.transferTargetId && ((co.recentOrder.orderPlacement.requestId && co.recentOrder.orderPlacement.customerNotes) || (!co.recentOrder.orderPlacement.requestId && co.orderingContextModel.customerNotes)));
    ck(v,6,0,currVal_1);
    const currVal_2:any = (co.showPayment && !co.recentOrder.orderInitiation.transferTargetId);
    ck(v,9,0,currVal_2);
  },(null as any));
}
export function View_OrderDetailsPanelComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵpid(0,import26.HtmlPipe,[import27.DomSanitizer]),
    import0.ɵpid(0,import28.PossessivePipe,([] as any[])),
    import0.ɵpid(0,import29.CurrencyPipe,([] as any[])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderDetailsPanelComponent_1)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderDetailsPanelComponent_8)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderDetailsPanelComponent_9)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderDetailsPanelComponent_11)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import30.OrderDetailsPanelComponent = v.component;
    const currVal_0:any = co.showFulfilmentDetails;
    ck(v,4,0,currVal_0);
    const currVal_1:any = ((co.showLocationDetails && !co.recentOrder.orderInitiation.transferTargetId) && (co.recentOrder.orderInitiation.orderTypeEnum !== co.OrderType.ORDER_AT_TABLE));
    ck(v,7,0,currVal_1);
    const currVal_2:any = (((co.showFulfilmentDetails && !co.recentOrder.orderInitiation.transferTargetId) && co.recentOrder.placedOrder.requestId) && (co.recentOrder.orderInitiation.orderTypeEnum === co.OrderType.ORDER_DELIVERY));
    ck(v,10,0,currVal_2);
    const currVal_3:any = co.showOrderDetails;
    ck(v,13,0,currVal_3);
  },(null as any));
}
function View_OrderDetailsPanelComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-order-details-panel',([] as any[]),(null as any),(null as any),(null as any),View_OrderDetailsPanelComponent_0,RenderType_OrderDetailsPanelComponent)),
    import0.ɵdid(573440,(null as any),0,import30.OrderDetailsPanelComponent,[
      import9.SessionModel,
      import11.OrderingContextModel,
      import25.OrderModel,
      import5.NavigationService
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const OrderDetailsPanelComponentNgFactory:import0.ComponentFactory<import30.OrderDetailsPanelComponent> = import0.ɵccf('woa-order-details-panel',import30.OrderDetailsPanelComponent,View_OrderDetailsPanelComponent_Host_0,{
  recentOrder: 'recentOrder',
  showFulfilmentDetails: 'showFulfilmentDetails',
  showLocationDetails: 'showLocationDetails',
  showOrderDetails: 'showOrderDetails',
  showPayment: 'showPayment'
}
,{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/order/order-details-panel/order-details-panel.component.ngfactory.ts